module.exports = __webpack_public_path__ + "media/images/shared/icon_search-55221cdb3087ef82cb729280ea2ef5f3.png";